import React from 'react'

const ContactUpdated = () => {
  return (
    <div className='pt-12 pb-24 px-32 '>
        <div className='flex flex-col gap-5 justify-center items-center'>
            <span><hr className='h-2 w-28 bg-[#273773]'/></span>
            <span className='text-5xl tracking-wide font-medium opacity-90'>Are You Ready To Work With Us?</span>
            <span className='text-lg font-light opacity-80 w-[50rem] text-center'>Vyda Agency isn't just a marketing agency; it's a powerhouse of creativity, PR mastery, and strategic brilliance.it's a powerhouse of creativity, PR mastery, and strategic brilliance.</span>
            <span className='flex gap-5'>
                <span className='px-6 py-2 rounded-lg font-normal text-base bg-[#273773] text-white/90'>Contact Us</span>
                <span className='px-6 py-2 rounded-lg border border-[#273773] text-[#273773]/90 font-normal text-base'>About Us</span>
            </span>
        </div>
    </div>
  )
}

export default ContactUpdated;